// extracted by mini-css-extract-plugin
export var cardContainer = "_oc-0";
export var cardHeader = "_oc-2";
export var collapsedState = "_oc-3";
export var dragHandle = "_oc-5";
export var dragHandleIcon = "_oc-6";
export var dragging = "_oc-1";
export var titleArea = "_oc-4";